import React from "react";

interface Props {
  type: string;
  size?: string;
}

const Icon: React.FC<Props> = ({ type, size }) => {
  return <i className={`la la-${type}`}></i>;
};

export default Icon;
